import React from "react";
import { Chip, Box, Grid } from "@mui/material";
import { StyledGoogleMaps } from "../../../styled/googleMaps";
import { getTramoGestionTitle, locationFromCoords, summarizePunto } from "./fptTrasladosUtils";
import TramoGestionFields from "./tramoGestionFields";
import AgenciasAsignacionMap from "../../art/traslados/pendientes/AgenciasAsignacionMap/AgenciasAsignacionMap";
import { useFormikContext } from "formik";

const TramoGestionCard = ({
  origen,
  destino,
  tramoIndex,
  tramosCount,
  namePrefix,
  disabled,
  tiposTransporte,
  motivosTraslado,
  agencias,
  prestadoresTraslado,
  showAgencia,
  showMap = true,
  idArt,
}) => {
  const formik = useFormikContext();
  const setFieldValue = formik?.setFieldValue;

  const origenLoc = locationFromCoords(
    origen?.latitud ?? origen?.location?.lat,
    origen?.longitud ?? origen?.location?.lng,
  );
  const destinoLoc = locationFromCoords(
    destino?.latitud ?? destino?.location?.lat,
    destino?.longitud ?? destino?.location?.lng,
  );

  const isCancelado = destino?.idEstado === 7 || destino?.cancelado;

  return (
    <StyledGoogleMaps.GestionCard variant="outlined">
      <StyledGoogleMaps.RecorridoRowHeader>
        <StyledGoogleMaps.RecorridoSummary>
          <StyledGoogleMaps.RecorridoIndexBadge>
            {tramoIndex}
          </StyledGoogleMaps.RecorridoIndexBadge>
          <StyledGoogleMaps.RecorridoTitle variant="subtitle1">
            {getTramoGestionTitle(origen, destino, tramoIndex, tramosCount)}
          </StyledGoogleMaps.RecorridoTitle>
          <Chip
            color={destino.esRetorno ? "default" : "primary"}
            label={destino.esRetorno ? "Vuelta" : "Ida"}
            size="small"
            variant="outlined"
          />
          {isCancelado && (
            <Chip
              color="error"
              label="Cancelado"
              size="small"
              sx={{ ml: 1 }}
            />
          )}
          {disabled && !isCancelado ? (
            <Chip
              color="warning"
              label="Tramo no editable"
              size="small"
              variant="outlined"
            />
          ) : null}
        </StyledGoogleMaps.RecorridoSummary>
      </StyledGoogleMaps.RecorridoRowHeader>
      <StyledGoogleMaps.RecorridoRowBody>
        <Grid container spacing={2}>
          <Grid item xs={12} md={showAgencia && showMap ? 7 : 12}>
            <TramoGestionFields
              agencias={agencias}
              prestadoresTraslado={prestadoresTraslado}
              disabled={disabled || isCancelado}
              motivosTraslado={motivosTraslado}
              namePrefix={namePrefix}
              requiredMarks
              showAgencia={showAgencia}
              showHelpers
              tiposTransporte={tiposTransporte}
            />
          </Grid>
          {showAgencia && showMap && (
            <Grid item xs={12} md={5}>
              <Box sx={{ height: '100%', minHeight: 300, display: 'flex', flexDirection: 'column' }}>
                <AgenciasAsignacionMap
                  agencias={agencias}
                  idArt={idArt}
                  origen={origenLoc}
                  destino={destinoLoc}
                  origenLabel={summarizePunto(origen)}
                  destinoLabel={summarizePunto(destino)}
                  selectedAgenciaId={destino?.idAgencia}
                  onSelectAgencia={(agenciaId) => {
                    if (setFieldValue) {
                      setFieldValue(`${namePrefix}.idAgencia`, agenciaId);
                      const match = (agencias || []).find((a) => String(a.id) === String(agenciaId));
                      if (match?.idPrestador) {
                        setFieldValue(`${namePrefix}.idPrestadorTraslado`, String(match.idPrestador));
                      }
                    }
                  }}
                  interactive={!disabled && !isCancelado}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </StyledGoogleMaps.RecorridoRowBody>
    </StyledGoogleMaps.GestionCard>
  );
};

export default TramoGestionCard;
